<div class="loading-screen-wrapper" #scrollTarget #responsive>
    <div class="container">
        <h1 class="loading-screen-text text">ARGON </h1>
        <div class="loadContainer" >
            <div class="ring"></div>
            <div class="ring"></div>
            <div class="ring"></div>
        </div>
    </div>

</div>